import TransformationCapabilitiesDto from "../../classes/dtos/transformationmodule/TransformationCapabilitiesDto";
import TransformationOptionsDto from "../../classes/dtos/transformationmodule/TransformationOptionsDto";
import TransformationOptionDto from "../../classes/dtos/transformationmodule/TransformationOptionDto";
import TransformationLinkDto from "../../classes/dtos/transformationmodule/TransformationLinkDto";
import TransformationNotConfigurableDto from "../../classes/dtos/transformationmodule/TransformationNotConfigurableDto";
import DataTypeDto from "../../classes/dtos/datastructuremodule/DataTypeDto";

export default class TransformationMapper {

    static ToDto(e: any): TransformationCapabilitiesDto | null {

        if (e.$type === "TransformationOptions") {
            return new TransformationOptionsDto(e.logicId, e.label, e.icon, new DataTypeDto(e.sourceDataType.type, e.sourceDataType.isMultiple, e.sourceDataType.label), new DataTypeDto(e.targetDataType.type, e.targetDataType.isMultiple, e.targetDataType.label), e.$type, e.options.map((x: any) => new TransformationOptionDto(x.id, x.label)));
        }

        if (e.$type === "TransformationNotConfigurable") {
            return new TransformationNotConfigurableDto(e.logicId, e.label, e.icon, new DataTypeDto(e.sourceDataType.type, e.sourceDataType.isMultiple, e.sourceDataType.label), new DataTypeDto(e.targetDataType.type, e.targetDataType.isMultiple, e.targetDataType.label), e.$type);
        }

        if (e.$type === "TransformationLink") {
            return new TransformationLinkDto(e.logicId, e.label, e.icon, new DataTypeDto(e.sourceDataType.type, e.sourceDataType.isMultiple, e.sourceDataType.label), new DataTypeDto(e.targetDataType.type, e.targetDataType.isMultiple, e.targetDataType.label), e.$type);
        }

        alert(e.$type + " not managed");

        return null;
    }
}